
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import MainDeptForm from '../components/forms/MainDeptForm';
import '../styles/EmployeeMaster.css';
import MainDeptTable from '../components/MainDeptTable';

const MainDeptModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/maindept/add';

  const handleAddClick = () => {
    navigate('/maindept/add');
  };

  const handleCloseModal = () => {
    navigate('/maindept');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Dept Category Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Dept Category
        </button>
      </div>

      <MainDeptTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Main Dept</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MainDeptForm />
        </Modal.Body>
        
      </Modal>
    </div>
  );
};

export default MainDeptModel;
